import React from "react";
import { useSelector } from "react-redux";
import {
  FROZEN_TEMPERATURE,
  COLD_TEMPERATURE,
  AGRI_SEASON_TEMPERATURE,
  WARM_TEMPERATURE,
  BOLLING_TEMPERATURE,
  MIN_HOT_TEMPERATURE,
} from "../../Constants";
import { useTheme } from "../../Hooks";
import useWindowDimensions from "../../Hooks/UseWindowDiemensions";
import { GeneralState } from "../../Redux";
import useStyles from "./FmTemperatureCard.style";

interface FmTemperatureCardProps {
  month: string;
  temperature: number;
  setTemperature: (newTemperature: number) => void;
}

const FmTemperatureCard = ({ temperature, setTemperature, month }: FmTemperatureCardProps) => {
  const classes = useStyles();
  const { width } = useWindowDimensions();
  const theme = useTheme();
  const { activeMetricMethod } = useSelector(GeneralState.Selectors.selectMetricMethods);
  const isMobile = width < theme.breakpoints.values.desktop;
  const frozen = (FROZEN_TEMPERATURE as any)[activeMetricMethod];
  const cold = (COLD_TEMPERATURE as any)[activeMetricMethod];
  const agri_season = (AGRI_SEASON_TEMPERATURE as any)[activeMetricMethod];
  const warm = (WARM_TEMPERATURE as any)[activeMetricMethod];
  const bolling = (BOLLING_TEMPERATURE as any)[activeMetricMethod];
  let iconToRender = "";

  switch (true) {
    case temperature >= frozen && temperature < cold:
      iconToRender = "./assets/TemperaturesIcon/Frozen.png";
      break;
    case temperature >= cold && temperature < agri_season:
      iconToRender = "./assets/TemperaturesIcon/ColdIcon.png";
      break;
    case temperature >= agri_season && temperature < warm:
      iconToRender = "./assets/TemperaturesIcon/AgriSeasonIcon.png";
      break;
    case temperature >= warm && temperature < bolling:
      iconToRender = "./assets/TemperaturesIcon/Warm.png";
      break;
    case temperature >= bolling:
      iconToRender = "./assets/TemperaturesIcon/Boiling.png";
      break;
  }

  const handleMinus = () => {
    setTemperature(temperature - 1);
  };

  const handlePlus = () => {
    setTemperature(temperature + 1);
  };

  if (isMobile) {
    return (
      <div className={classes.mobile_container}>
        <div className={classes.firstCol}>
          <div className={classes.mobile_month}>{month}</div>
        </div>

        <div className={classes.secondCol}>
          <div className={classes.mobile_button} onClick={handleMinus}>
            <img src="/multi-match/assets/Num_minus.png" alt="-" />
          </div>
          <div className={classes.tempField}>{temperature}&#xb0;</div>
          <div className={classes.mobile_button} onClick={handlePlus}>
            <img src="/multi-match/assets/Num_plus.png" alt="+" />
          </div>
        </div>
        <div className={classes.thirdCol}>
          <img src={iconToRender} alt="hot" width={28} />
        </div>
      </div>
    );
  }

  return (
    <div className={classes.container}>
      <div className={classes.firstRow_container}>
        <div className={classes.button} onClick={handleMinus}>
          <img src="/multi-match/assets/Num_minus.png" alt="-" />
        </div>
        <div className={classes.tempField}>{temperature}&#xb0;</div>
        <div className={classes.button} onClick={handlePlus}>
          <img src="/multi-match/assets/Num_plus.png" alt="+" />
        </div>
      </div>
      <div className={classes.secondRow_container}>
        <div className={classes.month}>{month}</div>
        <img src={iconToRender} alt="Icon" />
      </div>
    </div>
  );
};

export default FmTemperatureCard;
